<template>
<div :class="{'show-menu': showMenu}" class="user">
  <section class="user-info" @click="onMenuCtrlClick">
    <span class="user-name">{{userName}}</span>
  </section>
  <ul class="user-menu">
    <li
      v-for="(userMenu, index) in userMenus"
      :key="index"
      class="user-menu-item"
      @click="onUserMenuClick(userMenu)"
    >
      <i :class="userMenu.icon" class="fa" aria-hidden="true"></i>
      <span class="user-menu-label">{{userMenu.label}}</span>
    </li>
  </ul>
</div>
</template>

<script>
import BaseStore from '../BaseStore'
import * as EventKeyMap from './EventKeys'

export default {
  name: 'LayoutUser',
  extends: BaseStore,
  data () {
    return {
      showMenu: false
    }
  },
  computed: {
    userMenus () {
      return [{
        icon: 'fa-power-off',
        label: '注销',
        click: this.logout
      }]
    }
  },
  methods: {
    onMenuCtrlClick () {
      this.showMenu = !this.showMenu
    },
    onUserMenuClick (menu) {
      this.showMenu = false
      menu.click()
    },
    onWrapperClick (event) {
      if (this.$el.contains(event.target)) {
        return
      }

      this.showMenu = false
    },
    onUserMenuRegister (userMenu) {
      this.userMenus.unshift(userMenu)
    },
    onUserMenuDestroy (userMenu) {
      let {userMenus} = this
      let index = userMenus.indexOf(userMenu)

      if (index > -1) {
        userMenus.splice(index, 1)
      }
    },
    logout () {
      this.$api.Profile.logout().then(() => {
        if (process.env.AUTH_LOGOUT_URL) {
          setTimeout(() => {
            location.replace(process.env.AUTH_LOGOUT_URL.replace(/\{\{DIRECT_URI\}\}/, encodeURIComponent(location.href)))
          }, 0)
        }
      }).catch(console.error).finally(() => {
        this.$store.commit('Profile/removeToken')
      })
    }
  },
  created () {
    let {$eventBus} = this
    $eventBus.on(EventKeyMap.WRAPPER_CLICK, this.onWrapperClick)
    $eventBus.on(EventKeyMap.USER_MENU_REGISTER, this.onUserMenuRegister)
    $eventBus.on(EventKeyMap.USER_MENU_DESTROY, this.onUserMenuDestroy)
  },
  beforeDestroy () {
    let {$eventBus} = this
    $eventBus.off(EventKeyMap.WRAPPER_CLICK, this.onWrapperClick)
    $eventBus.off(EventKeyMap.USER_MENU_REGISTER, this.onUserMenuRegister)
    $eventBus.off(EventKeyMap.USER_MENU_DESTROY, this.onUserMenuDestroy)
  }
}
</script>

<style lang="scss" scoped>
.user {
  $TRANSITION-SECONDS: .1s;

  position: relative;
  height: 100%;
  z-index: 9;
  transition: background-color $TRANSITION-SECONDS, color $TRANSITION-SECONDS;
  overflow: hidden;

  &.show-menu {
    height: unset;
    /*background-color: #fff;*/
    background: #161E43;
    /*color: #606266;*/
    color: #ffffff;
    box-shadow: 0 0 10px 2px rgba(0, 0, 0, .15);

    > .user-info {
      font-size: 1rem;
      line-height: 2.875em;
    }

    > .user-menu {
      visibility: visible;
      opacity: 1;
    }
  }

  > .user-info {
    padding: 0 15px;
    text-align: center;
    cursor: pointer;
    transition: all $TRANSITION-SECONDS;
  }

  > .user-menu {
    visibility: hidden;
    margin: 0;
    padding: 5px 0;
    /*border-top: 1px solid #ebebeb;*/
    opacity: 0;
    transition: visibility $TRANSITION-SECONDS, opacity $TRANSITION-SECONDS;

    > .user-menu-item {
      padding: 0 15px;
      cursor: pointer;

      &:hover {
        /*background-color: #ecf5ff;*/
        /*color: #66b1ff;*/
        background: rgba(57, 69, 125, 0.95);
        color: #5B92FF;
      }

      > * {
        vertical-align: baseline;
      }

      > .user-menu-label {
        padding-left: 3px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/User.vue